import React from 'react';

const ErrorState = ({ message, retrySubmit }) => {
  return <div>
    {message ? <div>{message}</div>
      : <>
        <div>Ups... irgendetwas ist schief gelaufen.</div>
        <div>Bitte versuche es später noch einmal.</div>
        <div>Wenn der Fehler erhalten bleibt, bitte wende dich an unseren Support.</div>
      </>}
    <button onClick={retrySubmit}>Erneut versuchen</button>
  </div>;
};

export default ErrorState;
